import React from 'react'

function ListingAudit() {
  return (
    <section className="ttm-row grid-section clearfix">
  <div className="container">
    {/* row */}
    <div className="row">
      <div className="col-lg-12">
        {/* section title */}
        <div className="section-title title-style-center_text">
          <div className="title-header">
            <h3>OUR SERVICES</h3>
            <h2 className="title">Helping Your Business <b>Grow and Succeed </b></h2>
          </div>
        </div>{/* section title end */}
      </div>
    </div>
    {/* row */}
    <div className="row">
      <div className="col-lg-4 col-md-6 col-sm-6">
        {/*featured-imagebox*/}
        <div className="featured-imagebox featured-imagebox-services style1">
          {/* featured-thumbnail */}
          <div className="featured-thumbnail">
            <img className="img-fluid" src="images/services/services-01-768x512.jpg" alt="image" />
          </div>{/* featured-thumbnail end*/}
          <div className="featured-content">
            <div className="featured-title">
              <h3><a href="fabric-printing.html">Manufacturing Audits</a></h3>
              <div className="ttm-details-link">
                <a href="fabric-printing.html"><i className="themifyicon ti-arrow-top-right" /></a>
              </div>
            </div>
            <div className="featured-desc">
              <p>Nask International provides Manufacturing Audits to ensure the process quality of manufacturing and assembling for various products and parts. For complex and high-quality products, multiple audits may be required to meet industry standards.
                Our Manufacturing Audits cover a wide range of industries, including:
                Textiles & Garments, Towels & Allied Industries, Industrial Products, Consumer Goods, Pharmaceutical Products, Food & Confectionery.</p>
            </div>
          </div>
        </div>{/* featured-imagebox end*/}
      </div>
      <div className="col-lg-4 col-md-6 col-sm-6">
        {/*featured-imagebox*/}
        <div className="featured-imagebox featured-imagebox-services style1">
          {/* featured-thumbnail */}
          <div className="featured-thumbnail">
            <img className="img-fluid" src="images/services/services-02-768x512.jpg" alt="image" />
          </div>{/* featured-thumbnail end*/}
          <div className="featured-content">
            <div className="featured-title">
              <h3><a href="fabric-dyeing.html">Inline Quality Control
                </a></h3>
              <div className="ttm-details-link">
                <a href="fabric-dyeing.html"><i className="themifyicon ti-arrow-top-right" /></a>
              </div>
            </div>
            <div className="featured-desc">
              <p>NASK International conducts Inline Quality Control to monitor and maintain product quality at every stage of the production process. By implementing inspections during manufacturing, we detect defects early, prevent errors from escalating, and ensure that final products meet required quality standards.
                Across the globe, various pressure groups actively work toward ensuring the implementation of ethical standards in workplaces across all departments. Compliance with these standards fosters trust, credibility, and long-term success in the global market.</p>
            </div>
          </div>
        </div>{/* featured-imagebox end*/}
      </div>
      <div className="col-lg-4 col-md-6 col-sm-6">
        {/*featured-imagebox*/}
        <div className="featured-imagebox featured-imagebox-services style1">
          {/* featured-thumbnail */}
          <div className="featured-thumbnail">
            <img className="img-fluid" src="images/services/services-04-768x512.jpg" alt="image" />
          </div>{/* featured-thumbnail end*/}
          <div className="featured-content">
            <div className="featured-title">
              <h3><a href="manufacture.html">Final Quality Audits</a></h3>
              <div className="ttm-details-link">
                <a href="manufacture.html"><i className="themifyicon ti-arrow-top-right" /></a>
              </div>
            </div>
            <div className="featured-desc">
              <p>At Nask International, we recognize the growing global concern for environmental protection and safety across all industries. Ensuring sustainable and eco-friendly practices is essential for long-term success.
                Our Environmental Audits follow the internationally recognized ISO 14001 standards, which provide practical tools and guidelines for implementing environmental safety measures within organizations.
                Our ISO 14001 Environmental Audits help:
                Assess supplier factories for compliance
                Ensure sustainable environmental practices
                Enhance workplace safety and environmental responsibility
                Support businesses in reducing their environmental footprint</p>
            </div>
          </div>
        </div>{/* featured-imagebox end*/}
      </div>
    </div>
    {/* row end */}
  </div>
</section>

  )
}

export default ListingAudit